import styled from 'styled-components'
import { pxToRem } from '../utils'

// mensagem centralizada no lugar do conteúdo (lista vazia, QR inválido, falha)
const PageMessage = styled.div`
  color: #5b666d;
  min-height: ${pxToRem(240)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;

  strong {
    font-size: ${pxToRem(14)};
  }
`

export default PageMessage



// WEBPACK FOOTER //
// ./src/components/PageMessage.js